// extracted by mini-css-extract-plugin
export var banner = "_44-0";
export var icon = "_44-1";
export var message = "_44-2";